//Angular
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

//Components
import { CASBannerComponent } from './components/cas-banner/cas-banner';
import { CASGridComponent } from './components/cas-grid/cas-grid';
import { CASNavBoxComponent } from './components/cas-navbox/cas-navbox';
//import { CASTreeComponent } from './components/cas-tree/cas-tree';
import { ModalComponent } from './components/modal/modal';
//import { DropdownComponent } from './components/dropdown/dropdown';

//Modules

//Pipes
import { CASTreeNodesPipe } from './pipes/casTreeNodesPipe';
import { FormatDateTimePipe } from './pipes/formatDateTimePipe';
import { FormatDatePipe } from './pipes/formatDatePipe';

//Services
import { CPDFormatters } from './services/cpd-formatters';
import { FeatureFlagService } from './services/featureFlagService';
import { GrowlWrapperService } from './services/growlWrapperService';
import { WebServices } from './services/webServices';

//Directives
import { KeyEnterDirective } from './directives/on-enter-key.directive';
import { RouteOnEnterDirective } from './directives/route-on-enter.directive';
import { FieldValidationDirective } from './directives/field-validation.directive';


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// SharedModule
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

/* Services */
@NgModule({
    imports : [
      CommonModule,
      FormsModule
    ],
    
    declarations : [

        //Components
        CASBannerComponent,
        CASGridComponent,
        CASNavBoxComponent,
        //CASTreeComponent,
        ModalComponent,
        //DropdownComponent,

        //Directives
        FieldValidationDirective,
        KeyEnterDirective,
        RouteOnEnterDirective,

        //Pipes
        CASTreeNodesPipe,
        FormatDatePipe,
        FormatDateTimePipe
    ],
    
    providers: [
        CPDFormatters,
        FeatureFlagService,
        GrowlWrapperService,
        WebServices
    ],
    
    exports:[
        
        //Modules
        CommonModule,
        FormsModule,

        //Components
        CASBannerComponent,
        CASGridComponent,
        CASNavBoxComponent,
        //CASTreeComponent,
        ModalComponent,
        //DropdownComponent,

        //Directives
        FieldValidationDirective,
        KeyEnterDirective,
        RouteOnEnterDirective,

        //Pipes
        CASTreeNodesPipe,
        FormatDatePipe,
        FormatDateTimePipe
    ]
}) export class SharedModule {}

